var _style, _g, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyVoiceSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    width: "25px",
    height: "25px",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FCBC00;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.8,16.4c2.9,0,8.8,1.5,8.8,4.4V23H0v-2.2C0,17.9,5.9,16.4,8.8,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.2,6C9,6,8.7,6,8.5,6S8.1,6,7.9,6.1C6.8,6.3,5.8,6.7,5,7.5c-1,0.9-1.7,2-1.9,3.3c0,0.2,0,0.4-0.1,0.6 c0,0.2,0,0.5,0,0.7c0,0,0,0,0,0.1c0,0.9,0.3,1.8,0.8,2.4c0.9,1.5,2.3,2.4,4,2.7c0.2,0,0.4,0,0.6,0.1c0.2,0,0.5,0,0.7,0 c0.1,0,0.3,0,0.4,0c1.2-0.1,2.2-0.6,3-1.4c1-0.9,1.7-2,1.9-3.3c0-0.2,0-0.4,0.1-0.6c0-0.2,0-0.5,0-0.7s0-0.4-0.1-0.6 c-0.2-1.2-0.7-2.2-1.6-3.1C11.9,6.8,10.9,6.3,9.7,6C9.6,6.1,9.4,6.1,9.2,6z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.9,10.9c-0.1-0.5-0.1-1.1-0.2-1.6c-0.5-2.8-1.8-5.2-3.7-7.2L20.9,2c-0.4,0.4-0.8,0.8-1.1,1.1 c2.3,2.4,3.6,5.3,3.6,8.7s-1.3,6.3-3.6,8.7c0.4,0.4,0.8,0.8,1.2,1.2c0.1-0.1,0.1-0.2,0.2-0.3c2.3-2.4,3.5-5.2,3.8-8.5 c0-0.1,0-0.2,0-0.2C24.9,12.1,24.9,11.5,24.9,10.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.3,4.5c-0.4,0.4-0.8,0.8-1.1,1.1c1.7,1.7,2.6,3.8,2.6,6.2s-0.9,4.5-2.5,6.2c0.4,0.4,0.8,0.8,1.1,1.1 C22.2,15.4,22.5,8.6,18.3,4.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.6,15.4c0.4,0.4,0.8,0.8,1.1,1.1c2.7-2.5,2.8-7.1,0-9.7c-0.4,0.4-0.8,0.8-1.1,1.1 C16.7,10.2,16.6,13.4,14.6,15.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyVoiceSelected);
export default __webpack_public_path__ + "static/media/my-voice-selected.d6a3f2414d5b88fe3c3c6b7462b21f23.svg";
export { ForwardRef as ReactComponent };